import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { EASE } from "./Reveal";

const LINKS = [
  { label: "Agentic Alpha", href: "#platform" },
  { label: "Platform", href: "#platform-link" },
  { label: "Solutions", href: "#solutions" },
  { label: "Success Stories", href: "#success-stories" },
  { label: "Resources", to: "/resources" },
  { label: "About Us", href: "#leadership" },
];

const LOGO_BLACK = "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/zlx5url4_intugle_logo_H_black_cropped.webp";
const LOGO_WHITE = "https://customer-assets-rejwkqb3.emergentagent.net/job_intugle-ai-platform/artifacts/bziz90bu_intugle_logo_H_white_cropped.webp";

export const Wordmark = ({ light = false }) => (
  <img
    src={light ? LOGO_WHITE : LOGO_BLACK}
    alt="Intugle"
    className="h-12 w-auto"
  />
);

export const scrollToId = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = ({ onContact }) => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (href) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(href), 450);
    } else {
      scrollToId(href);
    }
  };

  const goHome = () => {
    if (location.pathname !== "/") navigate("/");
    else scrollToId("#top");
  };

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.1, ease: EASE }}
      className={`fixed top-0 inset-x-0 z-[100] transition-all duration-500 ${
        scrolled
          ? "bg-[#F7F5F0]/55 backdrop-blur-xl shadow-[0_8px_30px_-18px_rgba(62,40,24,0.28)] py-1.5"
          : "bg-[#F7F5F0]/20 backdrop-blur-md py-2.5"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <a
          href="/"
          data-testid="nav-wordmark"
          onClick={(e) => { e.preventDefault(); goHome(); }}
        >
          <Wordmark />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.to || l.href}
              data-testid={`nav-link-${(l.to || l.href).replace(/[#/]/g, "") || "home"}`}
              onClick={(e) => { e.preventDefault(); l.to ? navigate(l.to) : goAnchor(l.href); }}
              className="nav-link text-[13px] font-medium text-[#3E2818]/75 hover:text-[#3E2818] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <button
          data-testid="nav-get-in-touch-btn"
          onClick={() => onContact("Get in Touch")}
          className="btn-primary !py-2 !px-4 !text-[13px]"
        >
          Get in Touch
        </button>
      </div>
    </motion.header>
  );
};
